var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.districts)?_c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"size":"small","options":_vm.districts,"props":_vm.props,"clearable":""},on:{"change":_vm.activeChange,"clean":_vm.activeChange},model:{value:(_vm.selectedOptions),callback:function ($$v) {_vm.selectedOptions=$$v},expression:"selectedOptions"}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a9a12a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/DistrictCascader.vue
// module id = 1227
// module chunks = 0